import { render, staticRenderFns } from "./ManagementRouterView.vue?vue&type=template&id=59f11cdd&"
import script from "./ManagementRouterView.vue?vue&type=script&lang=js&"
export * from "./ManagementRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports